import { images } from '../constants';

const products = [
    {
        id: 1,
        image: images.product1Gallery1,
        name: "Cupcake",
        price: 20,
        disprice: 12,
        stock: 10,
        content: "Soft and moist cupcake topped with creamy frosting—perfect for dessert or a sweet snack anytime.",
        description: "Indulge in our freshly baked Cupcake, made with premium ingredients and topped with rich, velvety frosting. Whether you’re enjoying it with coffee or gifting it to someone special, this sweet treat adds joy to any moment. Available in a variety of flavors to suit every taste.",
        category: ["Baked Goods", "Sweet Snacks"],
        tags: ["baked", "sweet", "snack"],
        gallery: {
            image1: images.product1Gallery1,
            image2: images.product1Gallery2,
            image3: images.product1Gallery3,
            image4: images.product1Gallery4,
        },
        addInfo: [
            { id: 1, title: "Flavor", content: "Vanilla with Buttercream" },
            { id: 2, title: "Size", content: "Standard Single Piece" },
            { id: 3, title: "Shelf Life", content: "2 Days (Refrigerated)" },
            { id: 4, title: "Allergens", content: "Contains Eggs, Milk, Wheat" }
        ],
        comments: [
            {
                id: 1,
                image: images.product1Review1,
                name: "Emily Carter",
                date: "July 10, 2025",
                rating: 5,
                content: "Absolutely delicious! Soft, fresh, and the frosting is heavenly."
            },
            {
                id: 2,
                image: images.product1Review2,
                name: "Daniel Brooks",
                date: "July 12, 2025",
                rating: 4.5,
                content: "Perfect sweetness and goes great with my latte. Will order again!"
            }
        ]
    },
    {
        id: 2,
        image: images.product2Gallery1,
        name: "Cappuccino",
        price: 25,
        disprice: 20,
        stock: 8,
        content: "A rich and creamy blend of espresso and steamed milk, topped with a light foam—perfect for any time of day.",
        description: "Enjoy the smooth and balanced flavor of our Cappuccino, crafted with freshly brewed espresso, steamed milk, and a delicate foam layer. Ideal for a morning boost or an afternoon break, this classic coffee drink delivers warmth, comfort, and bold taste in every sip.",
        category: ["Hot Beverages", "Coffee Specials"],
        tags: ["coffee", "creamy", "hotdrink"],
        gallery: {
            image1: images.product2Gallery1,
            image2: images.product2Gallery2,
            image3: images.product2Gallery3,
            image4: images.product2Gallery4,
        },
        addInfo: [
            { id: 1, title: "Serving Size", content: "250ml Cup" },
            { id: 2, title: "Ingredients", content: "Espresso, Steamed Milk, Milk Foam" },
            { id: 3, title: "Caffeine Level", content: "Medium" },
            { id: 4, title: "Best Pairing", content: "Croissant, Cupcake" }
        ],
        comments: [
            {
                id: 1,
                image: images.product2Review1,
                name: "Liam Wright",
                date: "July 14, 2025",
                rating: 5,
                content: "Great taste and perfect balance of milk and espresso. My daily favorite!"
            },
            {
                id: 2,
                image: images.product2Review2,
                name: "Olivia Martinez",
                date: "July 15, 2025",
                rating: 4.5,
                content: "Smooth, creamy, and full of flavor. Highly recommend with a cupcake."
            }
        ]
    },
    {
        id: 3,
        image: images.product3Gallery1,
        name: "Doughnut",
        price: 50,
        disprice: 40,
        stock: 4,
        content: "Soft, sweet, and freshly baked doughnut with a golden crust and delicious glaze—perfect for coffee breaks.",
        description: "Indulge in our classic Doughnut, crafted with a fluffy, airy dough and coated in a lightly crisp glaze. Whether you like it plain or paired with a cup of coffee, this timeless treat satisfies every sweet craving with its comforting texture and delightful taste.",
        category: ["Baked Goods", "Sweet Snacks"],
        tags: ["baked", "glazed", "snack"],
        gallery: {
            image1: images.product3Gallery1,
            image2: images.product3Gallery2,
            image3: images.product3Gallery3,
            image4: images.product3Gallery4,
        },
        addInfo: [
            { id: 1, title: "Flavor", content: "Classic Glazed" },
            { id: 2, title: "Serving Size", content: "1 Piece" },
            { id: 3, title: "Allergens", content: "Wheat, Dairy, Eggs" },
            { id: 4, title: "Shelf Life", content: "1 Day (Fresh)" }
        ],
        comments: [
            {
                id: 1,
                image: images.product3Review1,
                name: "Ella Thompson",
                date: "July 14, 2025",
                rating: 5,
                content: "Super soft and tasty. Pairs perfectly with hot coffee!"
            },
            {
                id: 2,
                image: images.product3Review2,
                name: "Noah Patel",
                date: "July 15, 2025",
                rating: 4.5,
                content: "Fresh and delicious. A great pick for a sweet snack."
            }
        ]
    },
    {
        id: 4,
        image: images.product4Gallery1,
        name: "Latte",
        price: 20,
        disprice: 12,
        stock: 0,
        content: "Creamy espresso-based drink blended with steamed milk—smooth, balanced, and ideal for a cozy coffee break.",
        description: "Savor the perfect balance of bold espresso and silky steamed milk with our handcrafted Latte. Topped with a light foam layer, it offers a mellow and comforting taste that’s ideal for mornings or relaxed afternoons. Served hot, it's a café favorite loved by coffee enthusiasts everywhere.",
        category: ["Hot Beverages", "Coffee Specials"],
        tags: ["coffee", "creamy", "hotdrink"],
        gallery: {
            image1: images.product4Gallery1,
            image2: images.product4Gallery2,
            image3: images.product4Gallery3,
            image4: images.product4Gallery4,
        },
        addInfo: [
            { id: 1, title: "Size", content: "12oz / 355ml" },
            { id: 2, title: "Ingredients", content: "Espresso, Steamed Milk, Foam" },
            { id: 3, title: "Caffeine Level", content: "Medium" },
            { id: 4, title: "Best Served", content: "Hot" }
        ],
        comments: [
            {
                id: 1,
                image: images.product4Review1,
                name: "Daniel Brooks",
                date: "July 15, 2025",
                rating: 5,
                content: "So smooth and satisfying. My go-to coffee every day!"
            },
            {
                id: 2,
                image: images.product4Review2,
                name: "Maya Ali",
                date: "July 16, 2025",
                rating: 4.5,
                content: "Loved the creamy texture and balanced flavor."
            }
        ]
    },
    {
        id: 5,
        image: images.product5Gallery1,
        name: "Chocolate Cake",
        price: 100,
        disprice: 95,
        stock: 9,
        content: "Rich and moist chocolate cake topped with smooth ganache—perfect for satisfying your sweet cravings.",
        description: "Indulge in our decadent Chocolate Cake made with premium cocoa and layered with velvety ganache. Each bite offers a rich, moist texture and deep chocolate flavor that melts in your mouth. Whether enjoyed with coffee or on its own, it's a timeless dessert favorite.",
        category: ["Baked Goods", "Sweet Snacks"],
        tags: ["chocolate", "baked", "sweet"],
        gallery: {
            image1: images.product5Gallery1,
            image2: images.product5Gallery2,
            image3: images.product5Gallery3,
            image4: images.product5Gallery4,
        },
        addInfo: [
            { id: 1, title: "Serving Size", content: "1 Slice" },
            { id: 2, title: "Ingredients", content: "Cocoa, Flour, Eggs, Sugar, Ganache" },
            { id: 3, title: "Allergens", content: "Gluten, Dairy, Eggs" },
            { id: 4, title: "Best Paired With", content: "Hot Coffee or Milk" }
        ],
        comments: [
            {
                id: 1,
                image: images.product5Review1,
                name: "Emily Stone",
                date: "July 15, 2025",
                rating: 5,
                content: "Absolutely delicious! Rich flavor and super moist texture."
            },
            {
                id: 2,
                image: images.product5Review2,
                name: "Hamza Rehman",
                date: "July 16, 2025",
                rating: 4.8,
                content: "Perfect with a cappuccino. My favorite dessert from the shop!"
            }
        ]
    },
    {
        id: 6,
        image: images.product6Gallery1,
        name: "Hot Chocolate",
        price: 30,
        disprice: 25,
        stock: 6,
        content: "Creamy hot chocolate made with real cocoa and steamed milk—perfect for cozy moments and winter warmth.",
        description: "Warm up with our rich Hot Chocolate, crafted from premium cocoa and velvety steamed milk. Topped with whipped cream or marshmallows on request, this comforting drink is perfect for chilly days or anytime you crave a sweet, soothing treat.",
        category: ["Hot Beverages", "Sweet Snacks"],
        tags: ["cocoa", "hotdrink", "comfort"],
        gallery: {
            image1: images.product6Gallery1,
            image2: images.product6Gallery2,
            image3: images.product6Gallery3,
            image4: images.product6Gallery4,
        },
        addInfo: [
            { id: 1, title: "Size", content: "12 oz" },
            { id: 2, title: "Ingredients", content: "Cocoa, Steamed Milk, Sugar" },
            { id: 3, title: "Toppings", content: "Whipped Cream, Marshmallows (optional)" },
            { id: 4, title: "Best Time", content: "Winter Evenings, Coffee Breaks" }
        ],
        comments: [
            {
                id: 1,
                image: images.product6Review1,
                name: "Ayesha Malik",
                date: "July 12, 2025",
                rating: 5,
                content: "So creamy and rich! The perfect pick-me-up on cold days."
            },
            {
                id: 2,
                image: images.product6Review2,
                name: "Daniel Cruz",
                date: "July 13, 2025",
                rating: 4.7,
                content: "Delicious and comforting. Tastes like homemade chocolate."
            }
        ]
    },
    {
        id: 7,
        image: images.product7Gallery1,
        name: "Croissant",
        price: 60,
        disprice: 53,
        stock: 3,
        content: "Buttery and flaky croissant baked fresh daily—perfect for pairing with coffee or enjoying as a light breakfast.",
        description: "Savor the classic taste of our freshly baked Croissant. Light, airy layers with a golden crust make it the ideal companion to your morning coffee or afternoon tea. Enjoy plain or add butter, jam, or cheese for extra delight.",
        category: ["Baked Goods", "Sweet Snacks"],
        tags: ["baked", "snack", "sweet"],
        gallery: {
            image1: images.product7Gallery1,
            image2: images.product7Gallery2,
            image3: images.product7Gallery3,
            image4: images.product7Gallery4,
        },
        addInfo: [
            { id: 1, title: "Serving Size", content: "1 Piece" },
            { id: 2, title: "Texture", content: "Flaky and Buttery" },
            { id: 3, title: "Best Paired With", content: "Coffee, Tea" },
            { id: 4, title: "Allergens", content: "Wheat, Dairy" }
        ],
        comments: [
            {
                id: 1,
                image: images.product7Review1,
                name: "Emma Shah",
                date: "July 14, 2025",
                rating: 4.8,
                content: "Crispy on the outside and soft inside—just how a croissant should be!"
            },
            {
                id: 2,
                image: images.product7Review2,
                name: "Michael Lee",
                date: "July 15, 2025",
                rating: 5,
                content: "Pairs perfectly with a cappuccino. Tastes like Paris!"
            }
        ]
    },
    {
        id: 8,
        image: images.product8Gallery1,
        name: "Green Tea",
        price: 25,
        disprice: 22,
        stock: 0,
        content: "Soothing and refreshing green tea brewed with premium leaves—perfect for a calm and healthy moment.",
        description: "Enjoy a cup of wellness with our refreshing Green Tea. Rich in antioxidants and crafted from the finest leaves, it's a calming beverage perfect for relaxing breaks or health-conscious routines. Serve hot or iced for a rejuvenating experience.",
        category: ["Hot Beverages", "Cold Treats"],
        tags: ["tea", "hotdrink", "snack"],
        gallery: {
            image1: images.product8Gallery1,
            image2: images.product8Gallery2,
            image3: images.product8Gallery3,
            image4: images.product8Gallery4,
        },
        addInfo: [
            { id: 1, title: "Serving Size", content: "250ml" },
            { id: 2, title: "Ingredients", content: "Premium Green Tea Leaves" },
            { id: 3, title: "Caffeine", content: "Low" },
            { id: 4, title: "Health Benefits", content: "Antioxidant-Rich, Supports Metabolism" }
        ],
        comments: [
            {
                id: 1,
                image: images.product8Review1,
                name: "Sara Iqbal",
                date: "July 15, 2025",
                rating: 4.7,
                content: "Light and refreshing—definitely my go-to for a healthy tea break!"
            },
            {
                id: 2,
                image: images.product8Review2,
                name: "David Kim",
                date: "July 16, 2025",
                rating: 4.9,
                content: "Great quality tea. Helps me stay calm and focused at work."
            }
        ]
    },
    {
        id: 9,
        image: images.product9Gallery1,
        name: "Chocolate",
        price: 150,
        disprice: 120,
        stock: 22,
        content: "Rich and creamy chocolate treat made from the finest cocoa—perfect for a sweet indulgence anytime.",
        description: "Satisfy your cravings with our smooth and luscious Chocolate. Crafted with high-quality cocoa, this classic delight melts in your mouth, delivering a deep, satisfying flavor. Ideal for gifting, pairing with coffee, or enjoying as a quick treat.",
        category: ["Sweet Snacks", "Cold Treats"],
        tags: ["chocolate", "sweet", "snack"],
        gallery: {
            image1: images.product9Gallery1,
            image2: images.product9Gallery2,
            image3: images.product9Gallery3,
            image4: images.product9Gallery4,
        },
        addInfo: [
            { id: 1, title: "Weight", content: "100g" },
            { id: 2, title: "Cocoa Content", content: "70%" },
            { id: 3, title: "Flavor", content: "Dark Chocolate" },
            { id: 4, title: "Allergens", content: "May contain nuts and dairy" }
        ],
        comments: [
            {
                id: 1,
                image: images.product9Review1,
                name: "Ayesha Khan",
                date: "July 14, 2025",
                rating: 5,
                content: "Absolutely delicious and melts perfectly—love it with coffee!"
            },
            {
                id: 2,
                image: images.product9Review2,
                name: "Mark Spencer",
                date: "July 15, 2025",
                rating: 4.8,
                content: "Dark and rich flavor—exactly how chocolate should taste."
            }
        ]
    },
    {
        id: 10,
        image: images.product10Gallery1,
        name: "Sweet Cupcake",
        price: 180,
        disprice: 160,
        stock: 18,
        content: "Fluffy and moist cupcake topped with sweet frosting—perfect for dessert or a delightful snack.",
        description: "Indulge in our Sweet Cupcake, baked to perfection with soft vanilla sponge and topped with creamy frosting. Ideal for parties, coffee breaks, or whenever you crave something delicious. Made with fresh ingredients and a touch of love.",
        category: ["Baked Goods", "Sweet Snacks"],
        tags: ["sweet", "baked", "snack"],
        gallery: {
            image1: images.product10Gallery1,
            image2: images.product10Gallery2,
            image3: images.product10Gallery3,
            image4: images.product10Gallery4,
        },
        addInfo: [
            { id: 1, title: "Flavor", content: "Vanilla with Buttercream" },
            { id: 2, title: "Size", content: "Standard" },
            { id: 3, title: "Calories", content: "220 per piece" },
            { id: 4, title: "Allergens", content: "Contains eggs, dairy, and gluten" }
        ],
        comments: [
            {
                id: 1,
                image: images.product10Review1,
                name: "Emily Rose",
                date: "July 15, 2025",
                rating: 5,
                content: "So moist and delicious! My kids loved it too."
            },
            {
                id: 2,
                image: images.product10Review2,
                name: "Jason Malik",
                date: "July 16, 2025",
                rating: 4.7,
                content: "Perfect balance of sweetness and texture. Will buy again!"
            }
        ]
    },
    {
        id: 11,
        image: images.product11Gallery1,
        name: "Creamy Cappuccino",
        price: 80,
        disprice: 70,
        stock: 25,
        content: "A rich and smooth cappuccino made with freshly brewed espresso and velvety milk foam.",
        description: "Savor the comforting warmth of our Creamy Cappuccino. Crafted with premium espresso and topped with a thick layer of milk foam, this coffeehouse favorite brings balanced flavor and silky texture in every sip. Ideal for coffee lovers seeking bold taste with a gentle finish.",
        category: ["Hot Beverages", "Coffee Specials"],
        tags: ["creamy", "coffee", "hotdrink"],
        gallery: {
            image1: images.product11Gallery1,
            image2: images.product11Gallery2,
            image3: images.product11Gallery3,
            image4: images.product11Gallery4,
        },
        addInfo: [
            { id: 1, title: "Size", content: "Medium (12 oz)" },
            { id: 2, title: "Ingredients", content: "Espresso, Steamed Milk, Milk Foam" },
            { id: 3, title: "Caffeine", content: "95mg per serving" },
            { id: 4, title: "Serving Temp", content: "Hot (65–70°C)" }
        ],
        comments: [
            {
                id: 1,
                image: images.product11Review1,
                name: "Daniel Craig",
                date: "July 15, 2025",
                rating: 4.8,
                content: "Perfectly brewed with just the right amount of foam!"
            },
            {
                id: 2,
                image: images.product11Review2,
                name: "Sophia Karim",
                date: "July 16, 2025",
                rating: 5,
                content: "Smooth, rich, and relaxing. My go-to drink every morning!"
            }
        ]
    },
    {
        id: 12,
        image: images.product12Gallery1,
        name: "Glazed Doughnut",
        price: 60,
        disprice: 55,
        stock: 30,
        content: "Soft and fluffy doughnut coated with a shiny vanilla glaze for the perfect sweet bite.",
        description: "Indulge in our Glazed Doughnut — a classic treat that's light, airy, and covered in a smooth vanilla glaze. Baked to golden perfection, this doughnut melts in your mouth and pairs perfectly with your favorite coffee or tea. A timeless bakery delight for any time of day.",
        category: ["Baked Goods", "Sweet Snacks"],
        tags: ["glazed", "baked", "sweet"],
        gallery: {
            image1: images.product12Gallery1,
            image2: images.product12Gallery2,
            image3: images.product12Gallery3,
            image4: images.product12Gallery4,
        },
        addInfo: [
            { id: 1, title: "Size", content: "Standard (3.5 in diameter)" },
            { id: 2, title: "Flavor", content: "Vanilla Glaze" },
            { id: 3, title: "Calories", content: "250 kcal per doughnut" },
            { id: 4, title: "Allergens", content: "Contains wheat, eggs, milk" }
        ],
        comments: [
            {
                id: 1,
                image: images.product12Review1,
                name: "Michael Tran",
                date: "July 15, 2025",
                rating: 5,
                content: "So soft and sweet! Just the way a doughnut should be."
            },
            {
                id: 2,
                image: images.product12Review2,
                name: "Emily Rivers",
                date: "July 16, 2025",
                rating: 4.7,
                content: "Loved it with my cappuccino. Fresh and delicious!"
            }
        ]
    },
    {
        id: 13,
        image: images.product13Gallery1,
        name: "Milk Latte",
        price: 15,
        disprice: 12,
        stock: 25,
        content: "Smooth and creamy milk latte with rich espresso — a comforting classic in every sip.",
        description: "Enjoy the balanced harmony of espresso and steamed milk in our Milk Latte. Crafted with freshly brewed espresso and velvety steamed milk, this drink offers a mellow, smooth flavor perfect for both latte lovers and casual coffee drinkers. Ideal for a cozy start to your day or an afternoon pick-me-up.",
        category: ["Hot Beverages", "Coffee Specials"],
        tags: ["milk", "coffee", "hotdrink"],
        gallery: {
            image1: images.product13Gallery1,
            image2: images.product13Gallery2,
            image3: images.product13Gallery3,
            image4: images.product13Gallery4,
        },
        addInfo: [
            { id: 1, title: "Size", content: "Medium (12 oz)" },
            { id: 2, title: "Caffeine", content: "80 mg per serving" },
            { id: 3, title: "Milk Type", content: "Whole Milk (customizable)" },
            { id: 4, title: "Serving Temp", content: "Hot (served at ~60°C)" }
        ],
        comments: [
            {
                id: 1,
                image: images.product13Review1,
                name: "Aria Williams",
                date: "July 15, 2025",
                rating: 5,
                content: "Creamy and flavorful — exactly what I needed in the morning!"
            },
            {
                id: 2,
                image: images.product13Review2,
                name: "David Park",
                date: "July 16, 2025",
                rating: 4.8,
                content: "Very smooth and balanced. Loved every sip."
            }
        ]
    },
    {
        id: 14,
        image: images.product14Gallery1,
        name: "Chocolate Delight",
        price: 15,
        disprice: 12,
        stock: 20,
        content: "Rich and indulgent chocolate treat that melts in your mouth — a true delight for chocolate lovers.",
        description: "Satisfy your sweet tooth with our Chocolate Delight. This decadent dessert features layers of rich cocoa flavor, a soft, moist texture, and a silky finish. Perfect for pairing with coffee or enjoying as a standalone treat, it’s a must-try for any chocolate enthusiast.",
        category: ["Hot Beverages", "Coffee Specials"],
        tags: ["chocolate", "sweet", "cocoa"],
        gallery: {
            image1: images.product14Gallery1,
            image2: images.product14Gallery2,
            image3: images.product14Gallery3,
            image4: images.product14Gallery4,
        },
        addInfo: [
            { id: 1, title: "Flavor", content: "Dark Chocolate" },
            { id: 2, title: "Size", content: "Single Serving" },
            { id: 3, title: "Allergens", content: "Contains dairy, eggs" },
            { id: 4, title: "Serving Temp", content: "Best served warm" }
        ],
        comments: [
            {
                id: 1,
                image: images.product14Review1,
                name: "Lena Smith",
                date: "July 15, 2025",
                rating: 5,
                content: "Heavenly taste! The perfect chocolate fix with my espresso."
            },
            {
                id: 2,
                image: images.product14Review2,
                name: "Marcus Allen",
                date: "July 16, 2025",
                rating: 4.7,
                content: "Delicious and rich. Great with coffee or on its own!"
            }
        ]
    },
    {
        id: 15,
        image: images.product15Gallery1,
        name: "Hot Cocoa",
        price: 15,
        disprice: 12,
        stock: 25,
        content: "Smooth and comforting hot cocoa made with rich cocoa powder and creamy milk — perfect for chilly days.",
        description: "Warm up with our Hot Cocoa, a classic beverage crafted from high-quality cocoa and steamed milk. Topped with whipped cream or marshmallows for extra indulgence, it's a cozy drink that soothes the soul and delights your taste buds, any time of day.",
        category: ["Hot Beverages", "Sweet Snacks"],
        tags: ["cocoa", "hotdrink", "sweet"],
        gallery: {
            image1: images.product15Gallery1,
            image2: images.product15Gallery2,
            image3: images.product15Gallery3,
            image4: images.product15Gallery4,
        },
        addInfo: [
            { id: 1, title: "Cocoa Type", content: "Rich Dutch-processed" },
            { id: 2, title: "Toppings", content: "Whipped Cream / Marshmallows" },
            { id: 3, title: "Serving Temp", content: "Hot" },
            { id: 4, title: "Sweetness", content: "Medium" }
        ],
        comments: [
            {
                id: 1,
                image: images.product15Review1,
                name: "Jasmine Cole",
                date: "July 15, 2025",
                rating: 5,
                content: "Perfectly creamy and not too sweet. Great for relaxing evenings."
            },
            {
                id: 2,
                image: images.product15Review2,
                name: "Ethan Moore",
                date: "July 16, 2025",
                rating: 4.8,
                content: "A comfort drink done right. I always add marshmallows!"
            }
        ]
    }

];

export default products;